import axios from 'axios';
import { formatErrorMessage } from '@/utils/errorUtils';

const API_URL = process.env.VUE_APP_API_URL || 'http://0.0.0.0/api';
const API_BASE_URL = `${API_URL}/calculations/tax`;

export async function calculateTax(formData: any): Promise<any> {
  try {
    // Convert startDate to YYYY-MM-DD format if needed
    let formattedStartDate = formData.startDate;
    if (formData.startDate) {
      // If it's a Date object, convert to YYYY-MM-DD using local timezone
      if (formData.startDate instanceof Date) {
        const year = formData.startDate.getFullYear();
        const month = (formData.startDate.getMonth() + 1).toString().padStart(2, '0');
        const day = formData.startDate.getDate().toString().padStart(2, '0');
        formattedStartDate = `${year}-${month}-${day}`;
      }
      // If it's a string in different format, try to convert
      else if (typeof formData.startDate === 'string') {
        const date = new Date(formData.startDate);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString().padStart(2, '0');
          formattedStartDate = `${year}-${month}-${day}`;
        }
      }
    }

    console.log('Original startDate:', formData.startDate);
    console.log('Formatted startDate:', formattedStartDate);

    // Map formData from wizard to API payload
    const payload = {
      businessId: formData.businessId || 1, // Assuming a default or it comes from form
      fatturatoPrecedente: formData.fatturatoPrecedente ?? undefined, // Use ?? to preserve 0
      fatturatoPrevisto: formData.fatturatoPrevisto,
      macroCategory: formData.category,
      isStartup: formData.isStartup,
      startDate: formattedStartDate, // YYYY-MM-DD format
      contributionRegime: formData.contributionRegime,
      year: formData.year || new Date().getFullYear(), // Assuming current year if not provided
      currentBalance: formData.currentBalance ?? undefined, // Use ?? to preserve 0
      useSafetyMargin: formData.useSafetyMargin || false,
      contributionReduction: formData.contributionReduction || 'NONE',
      hasOtherCoverage: formData.hasOtherCoverage || false,
      previousYearTaxAdvancesPaid: formData.previousYearTaxAdvancesPaid ?? undefined, // Use ?? to preserve 0
      previousYearInpsSaldoPaid: formData.previousYearInpsSaldoPaid ?? undefined, // Use ?? to preserve 0
      previousYearInpsAdvancesPaid: formData.previousYearInpsAdvancesPaid ?? undefined, // Use ?? to preserve 0
      previousYearProfessionalCasseDeductible: formData.previousYearProfessionalCasseDeductible ?? undefined, // Use ?? to preserve 0
      dataNascita: formData.dataNascita ? formatDateToISO(formData.dataNascita) : undefined,
    };

    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await axios.post(API_BASE_URL, payload, { headers });

    // Extract calculation data from wrapped response
    if (response.data.success && response.data.data && response.data.data.calculation) {
      return response.data.data.calculation;
    } else {
      throw new Error(response.data.message || 'Invalid response format');
    }
  } catch (error) {
    console.error('API Error:', error);
    throw new Error(formatErrorMessage(error));
  }
}

function formatDateToISO(date: Date | string): string {
  if (date instanceof Date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  if (typeof date === 'string') {
    const d = new Date(date);
    if (!isNaN(d.getTime())) {
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
  
  return date as string;
}
